import posthog from 'posthog-js';

const apiKey = import.meta.env.VITE_POSTHOG_KEY;
if (apiKey) {
  posthog.init(apiKey, {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
  });
}

export { posthog };
